import React from 'react';
import { Typography } from '@pw-tech/omni-ui';
import Image from 'next/image';
import { InfoIcon } from 'lucide-react';
const SkipCeePIWaiting = () => {
  return <article data-sentry-component="SkipCeePIWaiting" data-sentry-source-file="SkipCeePIWaiting.tsx">
      <Typography variant="heading3" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="SkipCeePIWaiting.tsx">
        Interview
      </Typography>
      <div className="p-5 border-2 border-[#F7E0B4] bg-[#FEFBE8] rounded-lg flex flex-col gap-3 mt-6">
        <div className="flex flex-col items-center gap-1 text-center">
          <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/5efc5de6-1603-43d7-a544-a44a4e555d68.svg" alt="waiting" width={40} height={40} data-sentry-element="Image" data-sentry-source-file="SkipCeePIWaiting.tsx" />
          <Typography variant="heading3" weight="semi-bold" className="!text-[#713F12]" data-sentry-element="Typography" data-sentry-source-file="SkipCeePIWaiting.tsx">
            Interview Pending
          </Typography>
        </div>
        <Typography variant="regular" className="!text-sm !text-[#3D3D3D] text-center" data-sentry-element="Typography" data-sentry-source-file="SkipCeePIWaiting.tsx">
          Your application has been received successfully. A{' '}
          <span className="font-bold">personal interview</span> will be scheduled as part of the
          admission process.
        </Typography>
        <ul className="list-disc pl-5 flex flex-col gap-1">
          <li>
            <Typography variant="regular" className="!text-sm !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="SkipCeePIWaiting.tsx">
              <span className="font-bold">Next Steps:</span> Our team will reach out to you within{' '}
              <span className="font-bold">5–7 working days</span> to schedule your interview.
            </Typography>
          </li>
          <li>
            <Typography variant="regular" className="!text-sm !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="SkipCeePIWaiting.tsx">
              <span className="font-bold">What to Expect:</span> The interview will assess your
              profile, aspirations, and readiness for the program.
            </Typography>
          </li>
        </ul>
      </div>

      <div className="flex items-start gap-2 mt-2">
        <div className="flex-shrink-0 flex items-center justify-center mt-0.5">
          <InfoIcon size={20} color="#000000" data-sentry-element="InfoIcon" data-sentry-source-file="SkipCeePIWaiting.tsx" />
        </div>
        <Typography variant="regular" className="!text-sm !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="SkipCeePIWaiting.tsx">
          Please keep an eye on your email and phone for your{' '}
          <span className="font-bold">interview schedule</span> and further instructions.
        </Typography>
      </div>
    </article>;
};
export default SkipCeePIWaiting;